export function getProductIdsUsingContentIds(campaign) {
  return campaign.productMetas
    .filter(meta => meta.contentIds.length > 0)
    .map(meta => meta.productId);
}

export function getLineIdsUsingContentIds(campaign, campaignLinesById) {
  const productIdsToClean = getProductIdsUsingContentIds(campaign);
  return Object.values(campaignLinesById)
    .filter(line => productIdsToClean.includes(line.product.id))
    .map(line => line.id);
}
